// extracted by mini-css-extract-plugin
export default {"card":"card___2jILe","text":"text___3Cs1C","button":"button___2ud93"};